import React from "react"
import { GlobalWrapper } from "../lib/common"
import { ProfilePage } from "../lib/profile"

export default function MyApp() {
  return (
    <GlobalWrapper>
      <ProfilePage />
    </GlobalWrapper>
  )
}
